<template>
    <div>

    </div>
</template>

<script>
    export default {
        props: {
            content: Object
        },
        components: {},
        data() {
            return {
                //
            }
        }
    }
</script>
